/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1DestinationAllocation } from '../models/V1DestinationAllocation';
import { HttpFile } from '../http/http';

/**
* Request to create or update cross-destination impression distribution. Accepts one or more allocations. Using a single allocation returns the order line to single-destination behavior (subject to served-impression floor rules). The backend may trigger a redeploy so updated allocation-driven budgets are applied.
*/
export class SetDistributionRequest {
    /**
    * ID of the organization that owns the Order Line.
    */
    'orgId': string;
    /**
    * Destination allocations to persist. Must contain one or more allocations.
    */
    'allocations': Array<V1DestinationAllocation>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "allocations",
            "baseName": "allocations",
            "type": "Array<V1DestinationAllocation>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return SetDistributionRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

